import {apiGatewayRequest} from 'services/request/handler'

export function getStyx(route: string) {
    return apiGatewayRequest()
        .get(route)
        .then((res: Response) => res.json())
}
